import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import { CallrDocumentType } from './previewUserCallerId';

export class RequestUserCallerIdPayload {
  constructor(
    public documents: { id: string; type: CallrDocumentType }[],
    // Name of the Callr third party and caller ID label, edited in the preview
    public name: string,
    // Line appended to the user's notes, edited in the preview
    public note: string,
  ) {}
}

export interface RequestUserCallerIdResult {
  third_party: string;
  caller_id: number;
  state: string;
  documents: { type: string; label: string; state: string }[];
}

/**
 * Requests the user's caller ID at Callr with the documents confirmed in the preview, then logs it in the user's notes.
 */
async function requestUserCallerId(
  userUid: string,
  payload: RequestUserCallerIdPayload,
  auth: Authentication | null
): Promise<RequestUserCallerIdResult> {
  try {
    if (!auth) throw new RequestUserCallerIdFailure('Vous devez être connecté pour effectuer cette action.', 'unauthorized');

    const response = await HttpClient.post(`/backoffice/users/${userUid}/callerid/request`, { documents: payload.documents, name: payload.name, note: payload.note }, auth.token);

    return response.data;
  } catch (e) {
    if (e instanceof RequestUserCallerIdFailure) throw e;
    const errMessage = e instanceof Error ? e.message : typeof e === 'string' ? e : '';
    throw new RequestUserCallerIdFailure(
      errMessage.trim() || 'Demande de caller ID impossible. Réessayez plus tard.',
      'request-failed',
    );
  }
}

export class RequestUserCallerIdFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default requestUserCallerId;
